<script>
import ProfileImage from './UsersProfile/ProfileImage.vue';
import swal from 'sweetalert2';

export default {
    components: {
        'profile-image': ProfileImage,
    },

    props: {
        showDeleteProfileImage: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            showDeleteImageButton: this.showDeleteProfileImage,
        };
    },

    methods: {
        deleteProfileImage() {
            swal({
                title: this.$trans.get('common.are_you_sure'),
                text: this.$trans.get('common.cannot_undo'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: this.$trans.get('common.confirm_delete'),
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios.delete(route('users.profile.image.delete')).then(response => {
                        Events.$emit('page.users-profile.profile-image-changed', response.data.image);
                        this.showDeleteImageButton = false;
                    });
                })
                .catch(swal.noop);
        },
    },
};
</script>
